import React, { PureComponent } from 'react';
import Collapsible from 'react-collapsible';
import { cityDuration } from '../../../helpers/cyoaHelper';
import { ieCheck } from '../../../helpers/utils';
import _filter from 'lodash/filter';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import { CYOA_NETWORK_IDS } from '../../../config';

dayjs.extend(AdvancedFormat);


class TripDetailsCard extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      accordionOpen:false,
      accordiontransitionTime:300,
      isCyoa:(props.data.tour_id !== CYOA_NETWORK_IDS["europe"].id || props.data.tour_id !== CYOA_NETWORK_IDS["usa"].id ) ? true : false,
      passengers:props.data.passengers.length,
      tourName:this.dirtyCheck(props.data.tour_name),
      tourDate:this.dirtyCheck(props.data.departure_date),
      tourDuration:(props.data.tour_id !== CYOA_NETWORK_IDS["europe"].id || props.data.tour_id !== CYOA_NETWORK_IDS["usa"].id ) ? this.dirtyCheck(props.product[0].duration) : cityDuration(props.data.passengers[0].reservations),
      tourPrice: props.data.passengers[0].price.toFixed(2)
    }

    this.toggleCollapsible = this.toggleCollapsible.bind(this);
  }

  dirtyCheck(data){
    return (data === undefined || data === null || data === "") ? "" : data;
  }

  toggleCollapsible(){
    this.setState({accordionOpen: !this.state.accordionOpen});
  }

  renderCollapseHeader(data){

    const { currency, product, index, itineraries } = this.props;
    const { accordionOpen, isCyoa, tourName, tourDate, tourDuration, tourPrice, passengers } = this.state;


    const imageObj = {
      imageQuality:60,
      imageLink:(product[index].media !== undefined) ? _filter(product[index].media, {'title': 'highlightImages'})[0].url : ""
    }

    const standardImg = () => {
      return (
        <img
          className="lazyload original"
          alt=""
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          data-sizes="auto"
          data-srcset={`https:${imageObj.imageLink}?w=150&q=${imageObj.imageQuality} 1x,
          https:${imageObj.imageLink}?w=300&q=${imageObj.imageQuality} 2x`} />
      )
    }

    const ieImg = () => {
      return (
        <img
          alt=""
          src={`https:${imageObj.imageLink}?w=150&q=${imageObj.imageQuality}`} />
      )
    }

    const hasAccomIncluded  = (itineraries) => {
      let _acommodationTotal = 0;
      if(itineraries !== undefined && itineraries.sectors !== undefined){
        for(let i = 0; i < itineraries.sectors.length; i++){
          if(itineraries.sectors[i].accommodation.bookings !== undefined){
            _acommodationTotal += parseFloat(itineraries.sectors[i].accommodation.bookings.total);
          }
        }
      }
      return _acommodationTotal === 0 ? false : true;
    }


    return (
      <div className="payment-box-item head">
        <div className="row">
          <div className="column small-8 medium-9 column-spacing">
            <div className="row">
              <div className="column small-12 medium-2 hide-for-small-only">
              { ieCheck() ? ieImg() : standardImg() }
              </div>
              <div className="column small-12 medium-10">
                <p className="no-margin orange-text bold">{ tourName }</p>
                <p className="no-margin small-text large-inline">{ `${dayjs(tourDate).format('Do MMMM YYYY')} - ${dayjs(tourDate).add(tourDuration, 'days').format('Do MMMM YYYY')}`}</p>

                <p className="no-margin accomodation-text large-inline">
                  <span style={{display: (hasAccomIncluded(itineraries) && (data.tour_id === CYOA_NETWORK_IDS["europe"].id || data.tour_id === CYOA_NETWORK_IDS["usa"].id) )  ? 'inline-block' : 'none'}}>
                    <span className="ba-icon ba-icon-roomtype-alt"></span>
                    Accomodation included
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="column small-4 medium-3 column-spacing border-left">
            <p className="text-right no-margin">
              <span className="display-block">{currency}{tourPrice}</span>
              <span className="display-block small-text">{passengers} x adults</span>
              <span className="breakdown-text orange-text" style={{display: isCyoa ? 'none' : 'block'}}>
                {!accordionOpen  ? 'see breakdown' : 'close breakdown'}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className={!accordionOpen  ? '' : 'close'}><path fill="#ff6700" d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"/></svg>
              </span>
            </p>
          </div>
        </div>
      </div>
    )
  }


  render(){

      const { accordionOpen, accordiontransitionTime, isCyoa } = this.state;
      const { data, currency, itineraries } = this.props;

      const accomPrice = (itineraries) => {
        let arr = [];
        if(itineraries !== undefined && itineraries.sectors !== undefined){
          for(let i = 0; i < itineraries.sectors.length; i++){
            if(itineraries.sectors[i].accommodation.bookings !== undefined){
              arr.push(itineraries.sectors[i].accommodation.bookings.total);
            }else{
              arr.push("0.00");
            }
          }
        }
        return arr;
      }



      return (
        <Collapsible
          trigger={this.renderCollapseHeader(data)}
          open={accordionOpen}
          transitionTime={accordiontransitionTime}
          handleTriggerClick={this.toggleCollapsible}
          triggerDisabled={isCyoa}>
          <div className="payment-box-item expanded">

            {
              (data.tour_id !== CYOA_NETWORK_IDS["europe"].id || data.tour_id !== CYOA_NETWORK_IDS["usa"].id ) ? null :
              data.passengers[0].reservations.map((item, i) => {
                if(accomPrice(itineraries).length > 0){
                  return (
                    <div className="row" key={i}>
                      <div className="column small-8">
                        <p className="no-margin">
                          <span className="display-block">{`${item.start_city} - ${item.end_city}`}</span>
                          <span className="display-block bold date-text">{ dayjs(item.date_for).format('Do MMMM YYYY')}</span>
                        </p>
                      </div>
                      <div className="column small-4">
                        <p className="text-right no-margin">
                          <span className="display-block">{currency}{( parseFloat(item.price) + parseFloat(accomPrice(itineraries)[i])).toFixed(2) }</span>
                          <span className="small-text" style={{display:(i <  accomPrice(itineraries).length || accomPrice(itineraries)[i] !== undefined ) ? 'inline' : 'none' }}>inc accomodation {currency}{accomPrice(itineraries)[i]}</span>
                        </p>
                      </div>
                    </div>
                  )
                }
              })
            }
          </div>
        </Collapsible>
      )

  }

}

export default TripDetailsCard;



// WEBPACK FOOTER //
// ./src/components/confirmation/components/tripdetailscard.js